import React from "react";
import "./VerticalBar.scss";

const VerticalBar = ({
  number1 = "> Library <",
  color = "#000",
  lineHeight = "4px",
}) => {
  return (
    <div
      className="arc-vertical-bar2"
      style={{ "--lineHeight": lineHeight, "--color": color }}
    >
      <div>
        <div className="arc-vertical-bar__number2">{number1}</div>
      </div>
    </div>
  );
};

export default VerticalBar;
